document.addEventListener("DOMContentLoaded", function() {
    const items = document.querySelectorAll('.list__link');

    if (items.length === 0) return;

    
    const sidebar = document.getElementById('sidebar');
    const overlay = document.getElementById('overlay');
    const closeSidebarBtn = document.getElementById('close-sidebar');

    items.forEach(item => {
        item.addEventListener('click', function(e) {
            e.preventDefault();
            const imgSrc = this.querySelector('img').src;
            const desc1 = this.querySelector('.style-body-small').textContent;
            const desc2 = this.querySelectorAll('.style-body-small')[1].textContent;

            document.getElementById('sidebar-image').src = imgSrc;
            document.getElementById('sidebar-desc-1').textContent = desc1;
            document.getElementById('sidebar-desc-2').textContent = desc2;
        
            sidebar.style.right = '0';
            overlay.style.display = 'block';
        });
    });

    closeSidebarBtn.addEventListener('click', closeSidebar);
    overlay.addEventListener('click', closeSidebar);

    function closeSidebar() {
        sidebar.style.right = '-100%';
        overlay.style.display = 'none';
    }
});